import { AlertTriangle } from "lucide-react";

export default function Disclaimer({ text, compact = false }) {
  const fallback =
    "FINANCIAL DISCLAIMER: AI Trading Copilot provides automated quantitative analysis and market insights for educational purposes only. It does NOT execute trades and does NOT constitute financial advice. All trading decisions and capital risks remain 100% with the individual trader.";
  return (
    <div
      data-testid="disclaimer-banner"
      className={`flex gap-3 items-start bg-amber-500/10 border border-amber-500/20 text-amber-200/90 rounded-xl leading-relaxed ${
        compact ? "p-3 text-[11px]" : "p-4 text-xs sm:text-sm"
      }`}
    >
      <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5 text-amber-400" />
      <span>{text || fallback}</span>
    </div>
  );
}
